import { render, staticRenderFns } from "./testVaccination.vue?vue&type=template&id=61e63274"
import script from "./testVaccination.vue?vue&type=script&lang=js"
export * from "./testVaccination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e63274')) {
      api.createRecord('61e63274', component.options)
    } else {
      api.reload('61e63274', component.options)
    }
    module.hot.accept("./testVaccination.vue?vue&type=template&id=61e63274", function () {
      api.rerender('61e63274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testVaccination.vue"
export default component.exports